<template>
  <g>
    <path
      fill="#FFDE68"
      d="M63 126c34.79 0 63-28.21 63-63S97.79 0 63 0 0 28.21 0 63s28.21 63 63 63z"
    />
    <path
      fill="#fff"
      d="M52.78 58.09V44.03c0-5.6 4.58-10.19 10.15-10.19s10.15 4.6 10.15 10.19v14.06h5.04V44.03c0-8.4-6.77-15.19-15.13-15.19-8.36 0-15.13 6.8-15.13 15.19v14.06h4.92z"
    />
    <path
      fill="#fff"
      d="M81.8 88.35H44.2c-1.32 0-2.38-1.06-2.38-2.38V59.46c0-1.32 1.06-2.38 2.38-2.38h37.6c1.32 0 2.38 1.06 2.38 2.38v26.51c0 1.32-1.06 2.38-2.38 2.38z"
    />
    <path
      fill="#FFDE68"
      d="M63.06 65.15c-2.28 0-4.1 1.87-4.1 4.2 0 1.6.91 3 2.15 3.67v5.33c0 1.07.85 1.93 1.89 1.93s1.89-.87 1.89-1.93v-5.33c1.3-.73 2.15-2.07 2.15-3.67.12-2.34-1.7-4.2-3.98-4.2z"
    />
    <path
      stroke="#fff"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="5"
      d="M113.34 63.13c0-27.73-22.48-50.21-50.21-50.21-4.01 0-6.73.31-10.49 1.1C27.99 19.2 12.91 39.4 12.91 63.13c0 24.13 17.02 44.29 39.72 49.11"
    />
    <path
      stroke="#fff"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="5"
      d="M107.869 58.28l5.32 5.31 5.25-5.24"
    />
  </g>
</template>

<script>
export default {
  name: 'circleLock'
}
</script>

<style scoped></style>
